import React, { useEffect, useState } from "react";
import { getNotifications } from "../api";

const NotificationList = () => {
  const [notifications, setNotifications] = useState([]);

  useEffect(() => {
    const fetchNotifications = async () => {
      try {
        const response = await getNotifications();
        setNotifications(response.data);
      } catch (error) {
        console.error("Error fetching notifications:", error);
      }
    };

    fetchNotifications();
  }, []);

  return (
    <div>
      <h2>Notifications</h2>
      <ul>
        {notifications.map((notification) => (
          <li key={notification.notification_id}>
            {notification.title} - {notification.message}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default NotificationList;
